import { mapActions } from 'vuex';
import Events from '_utils/events';
import CustomerService from '_services/rest/modules/customer';

export default {
  name: 'customer-delete',
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
    ]),
    close() {
      this.setToggle({ type: 'confirm_modal', bool: false });
    },
    deleteRow() {
      this.setToggle({ type: 'progress', bool: true });
      CustomerService.deleteCustomer(this.selectCustomer)
        .then(() => {
          this.close();
          this.$router.push('/admin/clientes/lista/1');
          Events.$emit('update:pagination', false);
          this.activeAlert({ message: 'Cliente deletado com sucesso', theme: 'success' });
        })
        .catch(error => this.activeAlert({ message: error.message, theme: 'danger' }))
        .finally(() => this.setToggle({ type: 'progress', bool: false }));
    },
  },
};
